<template>
  <div
    class="step_container"
    :style="{
      '--color': colorSchema,
      '--stepShadow': stepShadow,
      '--startGradient': startGradient,
      '--endGradient': endGradient,
      '--completedGradient': completedGradient
    }"
  >
    <div class="row">
      <div class="step active completed">
        <div class="icon">
          <div class="centered">
            <img src="/assets/icons/checkmark.svg" />
          </div>
        </div>
      </div>
      <div class="separator">
        <hr :class="activeIndex >= 1 ? 'active' : ''" />
      </div>
      <div
        class="step"
        :class="[
          activeIndex >= 1 ? 'active' : '',
          activeIndex > 1 ? 'completed' : ''
        ]"
      >
        <div class="icon">
          <div class="centered">
            <img v-if="activeIndex >= 2" src="/assets/icons/checkmark.svg" />
            <span v-else>2</span>
          </div>
        </div>
      </div>
      <div class="separator">
        <hr :class="activeIndex >= 2 ? 'active' : ''" />
      </div>
      <div
        class="step"
        :class="[
          activeIndex >= 2 ? 'active' : '',
          activeIndex > 2 ? 'completed' : ''
        ]"
      >
        <div class="icon">
          <div class="centered">
            <img v-if="activeIndex >= 3" src="/assets/icons/checkmark.svg" />
            <span v-else>3</span>
          </div>
        </div>
      </div>
      <div class="separator">
        <hr :class="activeIndex >= 3 ? 'active' : ''" />
      </div>
      <div
        class="step"
        :class="[
          activeIndex >= 3 ? 'active' : '',
          activeIndex > 3 ? 'completed' : ''
        ]"
      >
        <div class="icon">
          <div class="centered">
            <span>4</span>
          </div>
        </div>
      </div>
      <div v-if="steps.length == 5" class="separator">
        <hr :class="activeIndex >= 3 ? 'active' : ''" />
      </div>
      <div
        v-if="steps.length == 5"
        class="step"
        :class="[
          activeIndex >= 4 ? 'active' : '',
          activeIndex > 4 ? 'completed' : ''
        ]"
      >
        <div class="icon">
          <div class="centered">
            <span>5</span>
          </div>
        </div>
      </div>
    </div>
    <span v-if="steps.length == 5" class="d-block d-sm-block d-md-block d-lg-none d-xl-none mt-4">Step {{ activeIndex + 1 }}: <span class="activeStep">{{ steps[activeIndex].title }}</span></span>
    <div class="row texts">
      <div class="step active">
        <div class="text">
          <span class="d-none d-sm-none d-md-none d-lg-block d-xl-block">{{steps[0].title}}</span>
        </div>
      </div>
      <div class="separator2"></div>
      <div class="step" :class="activeIndex >= 1 ? 'active' : ''">
        <div class="text">
          <span class="d-none d-sm-none d-md-none d-lg-block d-xl-block">{{steps[1].title}}</span>
        </div>
      </div>
      <div class="separator2"></div>
      <div class="step" :class="activeIndex >= 2 ? 'active' : ''">
        <div class="text">
          <span class="d-none d-sm-none d-md-none d-lg-block d-xl-block">{{steps[2].title}}</span>
        </div>
      </div>
      <div class="separator2"></div>
      <div class="step" :class="activeIndex >= 3 ? 'active' : ''">
        <div class="text">
          <span class="d-none d-sm-none d-md-none d-lg-block d-xl-block">{{steps[3].title}}</span>
        </div>
      </div>
      <div  v-if="steps.length == 5" class="separator2"></div>
      <div  v-if="steps.length == 5" class="step" :class="activeIndex >= 4 ? 'active' : ''">
        <div class="text">
          <span class="d-none d-sm-none d-md-none d-lg-block d-xl-block">{{steps[4].title}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "step-counter",
  props: {
    grid: {
      type: Object,
      default: () => {
        `backgroundColor: "#fff";
        `;
      }
    },
    steps: {
      type: Array,
      required: true
    },
    actions: {
      type: Object
    },
    activeIndex: {
      type: Number,
      required: false
    },
    colorSchema: {
      required: false,
      type: String,
      default: "#f3b238"
    },
    stepShadow: {
      required: false,
      type: String,
      default: ""
    },
    startGradient: {
      required: false,
      type: String,
      default: ""
    },
    endGradient: {
      required: false,
      type: String,
      default: ""
    },
    completedGradient: {
      required: false,
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
.step_container {
  padding: 70px 0 40px;
  div {
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
  }

  @media (max-width: 767px) {
    padding: 40px 20px 30px 20px;
  }
}
.step {
  opacity: 0.3;
  .icon {
    position: relative;
    background-color: #fff;
    box-shadow: 0px 4px 8px -2px var(--stepShadow);
    border-radius: 20px;
    border: 2px solid var(--color);
    min-width: 40px;
    width: 40px;
    height: 40px;
    span {
      font-size: 16px;
      line-height: 18.75px;
      color: var(--color);
    }
    .centered {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      span {
        // font-family: 'Cera Pro';
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  .text {
    text-align: center;
    width: 150px;
    @media (max-width: 992px) {
      width: 90px;
    }
    @media (max-width: 550px) {
      width: 70px;
    }
    @media (max-width: 400px) {
      width: 60px;
    }

    span {
      font-size: 14px;
      font-weight: 700;
      color: var(--color);

      @media (max-width: 992px) {
        font-size: 13px;
      }

      @media (max-width: 550px) {
        font-size: 12px;
      }

      @media (max-width: 400px) {
        font-size: 11px;
      }
    }

    // @media (max-width: 767px) {
    //   text-align: center;
    //   margin-top: 10px;
    // }
  }

  @media (min-width: 767px) {
    display: flex;
  }

  // @media (max-width: 767px) {
  //   padding-left: 0;
  //   padding-right: 0;
  // }

  &.active {
    opacity: 1;
  }

  &.completed {
    .icon {
      // background: linear-gradient(242.76deg, #f5be57 12.67%, #e89a0d 83.65%),
      //   #ffffff;

      background: var(--completedGradient);
      border: 0;
    }
    .centered {
      position: absolute;
      top: 51%;
      left: 51%;
      transform: translate(-50%, -50%);
    }
  }
}

.separator2 {
  width: calc(221px / 2);

  @media (max-width: 992px) {
    width: calc(100px / 2);
  }
  @media (max-width: 550px) {
    width: calc(60px / 2);
  }
  @media (max-width: 400) {
    width: calc(50px / 2);
  }
}

.texts {
  margin-top: 5px;
}

.step_container .separator {
  display: flex;
  width: 221px;
  @media (max-width: 992px) {
    width: 100px;
  }
  @media (max-width: 550px) {
    width: 60px;
  }
  @media (max-width: 400px) {
    width: 50px;
  }
  hr {
    display: block;
    height: 2px;
    border: 0;
    margin: 1em 0;
    padding: 0;
    width: 100%;
    background: var(--startGradient);
    &.active {
      background: var(--endGradient);
    }
  }

  @media (min-width: 767px) {
    align-items: center;
  }
}

.activeStep {
  color: #113B87;
  font-weight: bold;
}
</style>
